// Single source of truth for the frontend's build number. Bump this whenever
// you ship a change you want to be able to force out via the admin "Flush
// stale PWA clients" button. Keep it in lockstep with the Service Worker
// VERSION in /public/sw.js (so SW updates and the admin force-flush both
// agree on what "current" means).
//
// Convention: integer-only. Increment by 1 per visible build. The matching
// SW version string (e.g. "sv-v17") is what shows up in DevTools → Application
// → Service Workers, but the backend min_client_build only cares about the
// integer.
export const BUILD_VERSION = 46;
